import { Fetch } from "../interfaces/services/http";
import { baseUrlApi } from "../utils/constants";
import { getCurrentToken } from "./auth";

const request = async <T>({ method, body, url, controller }: Fetch) => {
  const token = await getCurrentToken();

  const response = await fetch(
    `${baseUrlApi}/${url}`,
    {
      method,
      body: JSON.stringify(body),
      signal: controller?.signal,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
  );

  if (!response.ok) {
    const error = await response.json();
    throw error;
  }

  return await response.json() as T;
};

export const post = async <T>({ url, body, controller }: Fetch) => {
  return request<T>({ method: "POST", body, url, controller });
};

export const put = async <T>({ url, body, controller }: Fetch) => {
  return request<T>({ method: "PUT", body, url, controller });
};

export const patch = async <T>({ url, body, controller }: Fetch) => {
  return request<T>({ method: "PATCH", body, url, controller });
};